import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdministrarAgendamientoVirtualComponent } from './administrar-agendamiento-virtual.component';


const routes: Routes = [
  { path: '', component: AdministrarAgendamientoVirtualComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdministrarAgendamientoVirtualRoutingModule { }
